<template>
  <Modal id="cancelEntityModal" data-bs-backdrop="static">
    <template #header>
      <h5 class="modal-title">{{ $t('key_cancel') }}</h5>
    </template>
    <template #body>
      <div class="row">
        <p>
          {{ $t('key_modalCancelConfirmation_question') }}
        </p>
      </div>
    </template>
    <template #footer>
      <button ref="closeButton" type="button" class="btn btn-outline-primary" data-bs-dismiss="modal">
        {{ $t('key_cancel') }}
      </button>
      <button type="button" class="btn bg-gradient-primary" @click="cancelEntity">
        {{ $t('key_confirm') }}
      </button>
    </template>
  </Modal>
</template>
  
<script>

  import Modal from "@/components/ModalHotakauth.vue";

  export default {
    components: { Modal },
    props: {
      entityId: {
        type: String,
        default: () => '',
      },
    },
    emits: ['cancel-entity'],
    data() {
      return {};
    },
    computed: {
      newUsuario() {
        return this.$store.state.user.newUser.status;
      },
    },
    created() {
      document.addEventListener("keydown", (event) => {
        if (event.key === "Escape") {
          this.hideModal();
        }
      });
    },
    methods: {
      hideModal() {
        let button = this.$refs.closeButton;
        if (button) button.click()
      },
      cancelEntity() {
        this.$emit('cancel-entity', this.entityId)
        this.hideModal()
      }
    }
  };

</script>
  
<style>

  .modal-usuarios .modal-container {
    width: 550px !important;
  }

</style>